export const Plus = ({ ...props }) => {
	return (
		<svg
			width={32}
			height={32}
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g id="32px/Plus">
				<path
					id="Vector 52"
					d="M16 9V23M23 16H9"
					stroke="#0E0E0E"
					strokeWidth={2}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
};
